import { Race } from '@app/rest-client/faxe/models';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { addManyRaces } from '@app/store/faxe/race/race.actions';

export const identifier = (a: Race): string => a.raceGuid;

export const adapter: EntityAdapter<Race> = createEntityAdapter<Race>({
  selectId: identifier
});

export type RaceEntityState = EntityState<Race>;

export const initialState: RaceEntityState = adapter.getInitialState({
  // additional entity state properties
});

const reducer = createReducer(
  initialState,
  on(addManyRaces, (state, { models }) => adapter.addMany(models, state))
);

export const raceReducer: (state: (RaceEntityState | undefined), action: Action) =>
  EntityState<Race> = (state: RaceEntityState | undefined, action: Action) =>
  reducer(state, action);

// get the selectors
const {
  selectAll
} = adapter.getSelectors();

// select the array of users
export const selectAllRace = selectAll;


